module.exports = __webpack_public_path__ + "static/media/AB_A6_7.cbd6e414.jpg";